import { createFileRoute } from '@tanstack/react-router'

import { ObjectDebugViewerPage } from '../../../../components/pages/backoffice/platform/object-debug-viewer/object-debug-viewer-page.tsx'
import { PermissionChecker } from '../../../../components/templates/permission-checker.tsx'

export const Route = createFileRoute('/bo/admin/debug')({
  component: () => (
    <PermissionChecker requiredPermissions={['tech.configurations']}>
      <ObjectDebugViewerPage />
    </PermissionChecker>
  ),
})
